module.exports = __webpack_public_path__ + "media/images/pages/sample_images/sample-lifestyle-e5f362056780981c52d10e2eec685643.jpeg";